import {
  EType,
  ITagResponseSchema,
} from '../../repositories/newbuilding-reviews/entities/get_reviews_web/TagResponseSchema';
import { ETagType, ITag } from '../../types/tag';

const mapper = {
  [EType.Adjoining_territory]: ETagType.Adjoining_territory,
  [EType.Construction]: ETagType.Construction,
  [EType.Developer]: ETagType.Developer,
  [EType.District]: ETagType.District,
  [EType.Flat]: ETagType.Flat,
  [EType.House]: ETagType.House,
  [EType.Infrastructure]: ETagType.Infrastructure,
  [EType.Kids]: ETagType.Kids,
  [EType.Management_company]: ETagType.Management_company,
  [EType.Parking]: ETagType.Parking,
  [EType.Purchase]: ETagType.Purchase,
  [EType.Transport_affordable]: ETagType.Transport_affordable,
};

export const prepareTagsFiltersStore = (tags: ITagResponseSchema[] | null | undefined): ITag[] => {
  if (!tags) {
    return [];
  }

  const mappedTags = tags.map(item => ({
    count: item.count,
    isSelected: item.isSelected,
    title: item.title,
    type: mapper[item.type],
  }));

  return mappedTags;
};
